// Copyright (c) 2022 Deere & Company

import './product-image.scss';
import React, {PropTypes} from 'react';

const ProductImage = props =>
    <div className='product-image-place-holder'>
        <div className='place-holder-text'>{props.placeHolderText}</div>
    </div>;

ProductImage.displayName = 'ProductImage';
ProductImage.propTypes = {
    baseCode: PropTypes.string,
    placeHolderText: PropTypes.string
};
ProductImage.defaultProps = {
    placeHolderText: 'image'
};

export default ProductImage;



// WEBPACK FOOTER //
// ./src/shared/components/product-image/index.js